import { render, staticRenderFns } from "./AddCompanyEmployeeModal.vue?vue&type=template&id=617d6d94&scoped=true&"
import script from "./AddCompanyEmployeeModal.vue?vue&type=script&lang=ts&"
export * from "./AddCompanyEmployeeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d6d94",
  null
  
)

export default component.exports